;(function () {
  'use strict'

  angular.module('contrast.rules').controller('RulesCtrl', RulesCtrl)

  function RulesCtrl(
    $scope,
    $timeout,
    UserService,
    RulesService,
    PromiseService,
    ErrorService,
    FeaturesService,
    ChartService,
    LanguagesService,
    AGENT_FEATURE,
    RULES_EXPAND_BREAKDOWN_PROPERTIES
  ) {
    'ngInject'

    var _searchKeywords = ''

    // API
    angular.extend($scope, {
      searchKeywords: searchKeywords,
      loadRulesByScroll: loadRulesByScroll,
      order: order,
      quickFilterSelect: quickFilterSelect,
      restoreDefaults: restoreDefaults,
      getAgentLanguageDisplayValue: getAgentLanguageDisplayValue
    })

    function _setDefaults() {
      angular.extend($scope, {
        model: {
          rules: [],
          numPerLoad: 15,
          count: 0,
          busy: true,
          updating: false,
          filteredRules: [],
          row: 'title',
          quickFilters: [],
          selectedQuickFilter: {
            name: 'RECOMMENDED',
            filterType: 'RECOMMENDED',
            count: '?'
          },
          emptyDevApps: true,
          emptyQaApps: true,
          emptyProdApps: true
        },
        expandProperties: RULES_EXPAND_BREAKDOWN_PROPERTIES
      })

      if (UserService.isFreemiumOrganization()) {
        $scope.model.selectedQuickFilter = {
          name: 'JAVA',
          filterType: 'JAVA',
          count: '?'
        }
      }
    }

    function init() {
      _setDefaults()
      $scope.model.busy = true
      _loadRules(0, $scope.model.numPerLoad)
      _getQuickFilters()
    }

    function _getQuickFilters() {
      if ($scope.model.quickFiltersPromise) {
        PromiseService.cancelPromise($scope.model.quickFiltersPromise)
      }

      $scope.model.quickFiltersPromise = RulesService.getQuickFilters(
        $scope.searchKeywords()
      )
        .then(function (filters) {
          $scope.model.quickFilters = filters
          $scope.model.selectedQuickFilter = $scope.model.quickFilters.find(
            function (filter) {
              return (
                filter.filterType == $scope.model.selectedQuickFilter.filterType
              )
            }
          )
        })
        .catch(ErrorService.processError)
    }

    function quickFilterSelect(filter) {
      $scope.model.busy = true
      $scope.model.rules = []
      $scope.model.selectedQuickFilter = filter
      _loadRules(0, $scope.model.numPerLoad)
    }

    function _loadRules(offset, limit) {
      if ($scope.model.rulesPromise) {
        PromiseService.cancelPromise($scope.model.rulesPromise)
      }

      var params = {
        quickFilter: $scope.model.selectedQuickFilter.filterType,
        q: $scope.searchKeywords(),
        limit: limit,
        offset: offset,
        sort: $scope.model.row,
        expand: $scope.expandProperties
      }

      $scope.model.rulesPromise = RulesService.get(params)
        .then(function (data) {
          $scope.model.rules = $scope.model.rules.concat(data.rules)
          $scope.model.busy = false
          $scope.model.count = data.count
          $timeout(function () {
            $scope.$emit('triggerScrollCheck')
          })

          var hasCustom = false

          _.each($scope.model.rules, function (rule) {
            if (
              !hasCustom &&
              (rule.customized_likelihood ||
                rule.customized_impact ||
                rule.customized_confidence)
            ) {
              hasCustom = true
              rule.isFirstCustom = true
            } else {
              rule.isFirstCustom = false
            }

            rule.isInAllLanguages = FeaturesService.isFeatureInAllLanguages(
              AGENT_FEATURE.ASSESS,
              rule.languages
            )

            rule.totalDev =
              rule.development_breakdown.off_applications.length +
              rule.development_breakdown.on_applications.length
            rule.totalQa =
              rule.qa_breakdown.off_applications.length +
              rule.qa_breakdown.on_applications.length
            rule.totalProd =
              rule.production_breakdown.off_applications.length +
              rule.production_breakdown.on_applications.length

            rule.development_breakdown.data = ChartService.buildAssessModeData(
              rule.development_breakdown,
              rule.totalDev
            )
            rule.qa_breakdown.data = ChartService.buildAssessModeData(
              rule.qa_breakdown,
              rule.totalQa
            )
            rule.production_breakdown.data = ChartService.buildAssessModeData(
              rule.production_breakdown,
              rule.totalProd
            )

            if (rule.totalDev > 0) {
              $scope.model.emptyDevApps = false
            }
            if (rule.totalQa > 0) {
              $scope.model.emptyQaApps = false
            }
            if (rule.totalProd > 0) {
              $scope.model.emptyProdApps = false
            }

            rule.env_data = []
            _addRuleEnvData(
              rule.env_data,
              rule.development_breakdown.data,
              rule.totalDev
            )
            _addRuleEnvData(rule.env_data, rule.qa_breakdown.data, rule.totalQa)
            _addRuleEnvData(
              rule.env_data,
              rule.production_breakdown.data,
              rule.totalProd
            )
          })
        })
        .catch(ErrorService.processError)
    }

    function _addRuleEnvData(envData, breakdown, total) {
      var ruleEnvData = {
        breakdown: breakdown,
        total: total
      }
      envData.push(ruleEnvData)
    }

    function searchKeywords(newSearchKeywords) {
      if (!arguments.length) {
        return _searchKeywords
      }

      if (newSearchKeywords !== _searchKeywords) {
        _searchKeywords = newSearchKeywords
      }

      $scope.model.busy = true
      $scope.model.rules = []
      _loadRules(0, $scope.model.numPerLoad)
      _getQuickFilters()

      return _searchKeywords
    }

    function loadRulesByScroll() {
      if (
        $scope.model.rules.length == $scope.model.count ||
        $scope.model.busy
      ) {
        return
      }

      $scope.model.busy = true
      $scope.scrollPromise = _loadRules(
        $scope.model.rules.length,
        $scope.model.numPerLoad
      )
      return $scope.scrollPromise
    }

    function order(rowName) {
      if ($scope.model.row === rowName) {
        return
      }

      $scope.model.busy = true
      $scope.model.rules = []
      $scope.model.row = rowName
      _loadRules(0, $scope.model.numPerLoad)
    }

    function restoreDefaults(rule) {
      $scope.model.updating = true
      RulesService.restoreDefaults(rule)
        .then(function (response) {
          var severity = response.severity
          _restoreCustomized(rule, severity)
          _updateRuleCustomized(rule.name, severity)
        })
        .catch(ErrorService.processError)
        .finally(function () {
          $scope.model.updating = false
        })
    }

    function _updateRuleCustomized(ruleName, severity) {
      var rule = _.find($scope.model.rules, function (rule) {
        return rule.name == ruleName
      })
      _restoreCustomized(rule, severity)
    }

    function _restoreCustomized(rule, severity) {
      rule.customized_likelihood = false
      rule.customized_impact = false
      rule.customized_confidence = false
      rule.severity = severity
    }

    function getAgentLanguageDisplayValue(languageValue) {
      return LanguagesService.getLanguage(languageValue).display
    }

    init()
  }
})()
